// extracted by mini-css-extract-plugin
export default {"label":"CommonQuillEditor_label__5Ja6D"};